import React, { useState } from "react";
// import "../App.css";
import ParallaxSection from '../components/ParallaxSection'
import LogoCarousel from "../components/LogoCarousel";
import SubBanner from "../components/SubBanner"
import HeartSection from "../components/Health/HeartSection";
import HeartBanner from "../components/Health/HeartBanner";
import SubStory from "../components/Health/SubStory"
import bgImage from "../Assets/Hospitality/hospitality-main.png";
import SubStone from "../components/Health/SubStone";
import SubFounder from "../components/Health/SubFounder";
import MedicalCareCarousel from "../components/Health/MedicalCareCarousel"
import founderPhoto from "../Assets/Hospitality/signature-experience.png";
import waveBg from "../Assets/background-wave.png";
import dotPattern from "../Assets/health/Ellipse 164.png";
import vcnrLogo from "../Assets/vcnr-logo-white.png";
import OutreachSection from "../components/Health/HealthcareCommunityOutreach";
import Img1 from "../Assets/Hospitality/solar-energy.png";
import Img2 from "../Assets/Hospitality/organic-farming.png";
import Img3 from "../Assets/Hospitality/plastic-free.png";
import TestimonialSlider from "../components/Health/TestimonialSlider";
import LeaderDivisionSection from "../components/Leadership/LeaderDivisionSection";
import VCNRContactHospitalBanner from "../components/Contact/VCNRContactHospitalBanner";
import LeaderBuildWithUs from "../components/Leadership/LeaderBuildWithUs";
import QuickAccessRow from "../components/Career/QuickAccessRow";
import testimonialbg from "../Assets//rock-bg.png"
import SubJoinSection from "../components/Health/SubJoinSection";
import doctorImage from "../Assets/contact/VCNR-hospital-Doctor.png";
import Subservicesmediacarousel from "../components/Health/Subservicesmediacarousel";
import hospitalImg from "../Assets/Hospitality/cottage-style.png";
import diagnosticsImg from "../Assets/Hospitality/spa-centre.png";
import instituteImg from "../Assets/Hospitality/table-dining.png";
import pharmacyImg from "../Assets/Hospitality/events-and-celebrations.png";
import healthparksImg from "../Assets/Hospitality/outdoor-activities.png";
import diamond from "../Assets/Hospitality/hospitality-banner.png";
import people from "../Assets/Hospitality/hospitality-banner.png";
import pulseLine from "../Assets/tech/pulse.png";
import TechClientsCollaborations from "../components/Tech/TechClientsCollaborations";
import doctorImage1 from "../Assets/Hospitality/vcnr-resorts.png"
import hospitalheart from "../Assets/health/Ellipse 164.png"
import seoMeta from "./seoMeta";
import { Helmet } from "react-helmet-async";
import SchoolCard from "../components/Foundation/SchoolCard";
import HospitalityBanner from "../components/Hospitality/HospitalityBanner"
import ComingSoon from "../components/ComingSoon";

const Hospitality = () => {
  const meta = seoMeta["/Hospitality"];
const logos = [
  { src: require('../Assets/LOGO/client1.png'), alt: 'Nestle' },
  { src: require('../Assets/LOGO/client2.png'), alt: 'Godrej' },
  { src: require('../Assets/LOGO/client3.png'), alt: 'Bajaj' },
  { src: require('../Assets/LOGO/client4.png'), alt: 'Reliance' },
  { src: require('../Assets/LOGO/client5.png'), alt: 'Safexpress' },
  { src: require('../Assets/LOGO/client6.png'), alt: 'JWL' },
  { src: require('../Assets/LOGO/client7.png'), alt: 'GIRIAS' },
  { src: require('../Assets/LOGO/client8.png'), alt: 'Nestle' },
    { src: require('../Assets/LOGO/client9.png'), alt: 'Denso' },
      { src: require('../Assets/LOGO/client10.png'), alt: 'Britania' },
        { src: require('../Assets/LOGO/client11.png'), alt: 'fsc' },
          { src: require('../Assets/LOGO/client12.png'), alt: 'ITC' },
            { src: require('../Assets/LOGO/client13.png'), alt: 'scope' },
            { src: require('../Assets/LOGO/client14.png'), alt: 'Flipkart' },
          ];
const paragraphs = [
    ` At VCNR Resorts, we believe true hospitality is about warmth, simplicity, and genuine care. Backed by the compassionate legacy of VCNR Healthcare, our resort is built not just to host, but to heal. Every stay is thoughtfully designed to rejuvenate the body and refresh the mind.`,
    `We bring together the care of our hospitality and warmth of nature to give you the best soothing experience.`,
  ];
const paragraphs1 = [
  `We measure our success with the success stories of our patients. Through words, videos, and shared memories, We honor the strength of those who have healed with us. Their stories inspire our teams to go further.`
];
const paragraphs2 = [
  `Plan your dream destination wedding, milestone event, or corporate retreat in a setting where nature adds its own magic. With expert event planners, customizable spaces, and warm hospitality, we make sure your big day is just as you imagined.`
]
  const healthcareCards = [
  { image: Img1 },
  { image: Img2 },
  { image: Img3 },
  { image: Img1 },
  { image: Img2 },
  { image: Img3 },
  { image: Img1 },
  { image: Img2 },
  { image: Img3 },
];
const quickAccessCards = [
  {
    title: "Book Your Stay",
    buttonText: "Download Recruitment Brochure",
    buttonLink: "#"
  },
  {
    title: "View Accommodation Options",
    buttonText: "Referral Program Info",
    buttonLink: "#",
  },
  {
    title: "Inquire About Wellness Packages",
    buttonText: "Contact VCNR HR Team",
    buttonLink: "#"
  },
  {
    title: "Download Resort Brochure (PDF)",
    buttonText: "Join Our WhatsApp Hiring Channel",
    buttonLink: "#"
  }
];

const aboutTestimonials = [
  {
    stars: 5,
    title: "Amazing Experience!",
    text: "The whole journey was seamless and smooth. Would recommend to everyone!",
    author: "Ravi Kumar",
    location: "India, Bangalore",
    img: "https://i.pravatar.cc/40?img=9",
  },
  {
    stars: 4,
    title: "Truly Professional",
    text: "The team was very helpful and knowledgeable. They guided us at every step and made sure we got the best outcome.",
    author: "Neha Patel",
    location: "India, Mumbai",
    img: "https://i.pravatar.cc/40?img=10",
  },
  {
    stars: 5,
    title: "Exceeded Expectations",
    text: "From the first call to the final delivery, everything was well-managed and executed beyond my expectations.",
    author: "Mohammed Irfan",
    location: "India, Hyderabad",
    img: "https://i.pravatar.cc/40?img=11",
  },
  {
    stars: 4,
    title: "Reliable Support",
    text: "Even after the service was completed, they stayed in touch and provided great support when needed.",
    author: "Divya Menon",
    location: "India, Kochi",
    img: "https://i.pravatar.cc/40?img=12",
  },
  {
    stars: 5,
    title: "Effortless Process",
    text: "The process was transparent and smooth. I didn’t feel stressed at all and was kept informed throughout.",
    author: "Ankit Sharma",
    location: "India, Delhi",
    img: "https://i.pravatar.cc/40?img=13",
  },
  {
    stars: 5,
    title: "Highly Recommended",
    text: "One of the best service providers I’ve come across. Their ethics, efficiency, and execution are remarkable.",
    author: "Kritika Jain",
    location: "India, Pune",
    img: "https://i.pravatar.cc/40?img=14",
  },
  {
    stars: 5,
    title: "Customer First Approach",
    text: "They truly put the customer first. Every need of ours was taken care of. Thank you for such a positive experience.",
    author: "Ramesh Babu",
    location: "India, Chennai",
    img: "https://i.pravatar.cc/40?img=15",
  },
  {
    stars: 4,
    title: "Smooth Collaboration",
    text: "We worked on a collaborative project and it went smoothly thanks to their clear communication and technical expertise.",
    author: "Sonal Kapoor",
    location: "India, Jaipur",
    img: "https://i.pravatar.cc/40?img=16",
  },
];

const servicesData = [
  {
    title: "Cottage-Style Accommodations",
    description: "Spacious, serene, and surrounded by nature",
    image: hospitalImg,
  },
  {
    title: "Wellness & Spa Centre",
    description: "Ayurvedic therapies, massage treatments, yoga, and meditation spaces",
    image: diagnosticsImg,
  },
  {
    title: "Farm-to-Table Dining",
    description: "Organic, seasonal, and locally sourced culinary experiences",
    image: instituteImg,
  },
  {
    title: "Event & Celebration Spaces",
    description: "Ideal for weddings, corporate retreats, and intimate gatherings",
    image: pharmacyImg,
  },
  {
    title: "Nature Trails & Outdoor Activities",
    description: "Cycling, birdwatching, and nature walks",
    image: healthparksImg,
  },

];


  return (
    <>
    <Helmet>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <meta name="keywords" content={meta.keywords} />
      </Helmet>
    <ComingSoon />
    {/* <Helmet>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <meta name="keywords" content={meta.keywords} />
      </Helmet>
      <HospitalityBanner />

<ParallaxSection><SubStory
      title="Our Philosophy"
      subtitle="Experience One Of The Best Premium Resorts Around Bangalore"
      paragraphs={paragraphs}
    /></ParallaxSection>
    <ParallaxSection><SubStone
  imageSrc={bgImage}
  heading={<>Here, you arrive as a <br />guest and leave as family.</>}
  buttonText="About Us"
  onButtonClick={() => window.location.href = "/about"}
/></ParallaxSection>
<ParallaxSection><Subservicesmediacarousel
      title={<>Resort Features<br />Relaxing Spa Resort Experience Redefined.</>}
      subtitle="Relaxing Spa Resort Experience Redefined."
      services={servicesData}
    /></ParallaxSection>
    <ParallaxSection>
      <SchoolCard
  schoolName={<>Signature Experiences<br />We own the Title "Good Resorts in Bangalore".</>}
  description="VCNR Resorts genuinely cares about your hospitality and offers the best curated experience specially for you."
  features={[
        "Weekend wellness retreats",
        "Cultural evenings & folk performances",
        "Sunrise yoga by the lake",
        "Bonfire nights and stargazing",
        "Personalized celebration planning"  ]}
  buttonText="Discover Our Experiences"
  buttonLink="/school"
  schoolBgImage={founderPhoto}
/>
 </ParallaxSection>
    <ParallaxSection><OutreachSection
          title="Sustainable Living Experience The Best Family Friendly Resort Near Bangalore"
          cardsData={healthcareCards}
          buttonText="Book an Appointment"
          onButtonClick={() => window.alert("Volunteer form will open")}
        /></ParallaxSection>
        <ParallaxSection><SubStory
      title={
    <>Your Special Moments, <br />
Perfectly Hosted
    </>
  }
      paragraphs={paragraphs2}

    />
    </ParallaxSection>
                <ParallaxSection><QuickAccessRow cards={quickAccessCards} /></ParallaxSection>
                <ParallaxSection><SubJoinSection
                  image={doctorImage1}
                  subtitle={<>VCNR Resorts</>}
                  description="At VCNR Resorts, every stay is a story. A story of connection, care, and calm. Come find your space to unwind, rediscover balance, and make memories in our luxury nature resort."
                  secondaryText=""
                /></ParallaxSection>
          <ParallaxSection><LogoCarousel logos={[...logos, ...logos]} /></ParallaxSection> */}
    </>
  );
};

export default Hospitality;
